import { render, staticRenderFns } from "./BaseClearButton.vue?vue&type=template&id=66f20eff&scoped=true"
import script from "./BaseClearButton.vue?vue&type=script&lang=js"
export * from "./BaseClearButton.vue?vue&type=script&lang=js"
import style0 from "./BaseClearButton.vue?vue&type=style&index=0&id=66f20eff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f20eff",
  null
  
)

export default component.exports